(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("algoliaBundle", [], factory);
	else if(typeof exports === 'object')
		exports["algoliaBundle"] = factory();
	else
		root["algoliaBundle"] = factory();
})(this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition